<template>
  <div class="home">
    <!-- 头部 -->

    <Head v-bind:headTxt="headTxt"></Head>

    <!-- 内容主体 -->
    <div class="content">
      <div class="content_l">
        <div class="bgc content_l_1">
          {{ nowDate }}
          <FlipClock style="margin-top: 1.5vh; margin-left: 0vh"></FlipClock>
          <!-- <iframe width="100%"
                  height="100%"
                  style="color: #000;"
                  src="https://i.tianqi.com?c=code&id=23&icon=6"
                  frameborder="0"
                  marginwidth="0"
                  marginheight="0"
                  scrolling="no"></iframe> -->
          <!-- <div id="he-plugin-simple"></div> -->
        </div>
        <div class="bgc content_l_2">
          <div class="content_l_2_title title">湖南省少数民族简介</div>
          <div class="content_l_2_box">
            <div style="margin: 1%">
              <el-carousel height="100%" indicator-position="none">
                <el-carousel-item
                  v-for="(item, index) in images_1"
                  :key="index"
                >
                  <el-image
                    style="width: 100%; height: 100%"
                    :src="item.idView"
                    fit="fit"
                  ></el-image>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div style="margin: 1%">
              <el-carousel height="100%" indicator-position="none">
                <el-carousel-item
                  v-for="(item, index) in images_2"
                  :key="index"
                >
                  <el-image
                    style="width: 100%; height: 100%"
                    :src="item.idView"
                    fit="fit"
                  ></el-image>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div style="margin: 1%">
              <ul>
                <li>少数民族：55个</li>
                <li>少数民族村：9019个</li>
                <li>少数民族人口：668.52万</li>
                <li>分布现状：大杂居，小聚居</li>
              </ul>
            </div>
            <div class="more" @click="textShow = true">more>>></div>
          </div>
        </div>
        <el-dialog
          title="湖南民族概况"
          :visible.sync="textShow"
          width="30vw"
          :append-to-body="true"
        >
          <p>
            湖南是少数民族人口大省，据2020年第七次人口普查55个少数民族在我省都有分布，全省少数民族总人口达668.5216万，占全省总人口的10.06%，少数民族人口位居全国第五位。有土家族、苗族、侗族、瑶族、白族、回族、壮族、维吾尔族等8个世居少数民族。全省土家族人口271.3005万、苗族人口202.7034万、侗族人口86.5518万、瑶族人口74.9872万、白族人口11.8638万、回族人口8.2786万、壮族人口4.5496万、维吾尔族人口1.1076万。少数民族人口100万以上的市州有湘西土家族苗族自治州、怀化市、张家界市;100万以下10万以上的有永州市、邵阳市、常德市、长沙市。
          </p>
          <p>
            全省有1个自治州(湘西土家族苗族自治州，辖龙山县永顺县、保靖县、花垣县、古丈县、凤凰县、泸溪县和吉首7)、7个自治县(通道侗族自治县、江华瑶族自治县、城步族自治县、新晃侗族自治县、芷江侗族自治县、靖州苗族侗放自治县、麻阳苗族自治县)、3个比照民族自治地方享受有关优惠政策的县区(桑植县、永定区、武陵源区)
            、6个少数民族人口过半县(绥宁县、会同县、沅陵县、江永县、石门县、慈利县)和84个民族乡。
          </p>
          <p>
            民族地区24个县市区占全省国土面积的28%，其中民族自治地方1州7县(即湘西土家族苗族自治州、7个少数民族自治县)占全省国土面积的17.8%。
          </p>
        </el-dialog>

        <div class="bgc content_l_3">
          <div class="content_l_3_title title">采样数据总量</div>
          <div>
            <el-divider
              ><span>{{ syDate.sampling_sum }}</span> 条</el-divider
            >
          </div>
        </div>
        <div class="bgc content_l_4">
          <div class="content_l_4_title title">样本数</div>
          <div class="content_l_4_text">
            县：{{
              yangBenShuData.aData
            }}
            个&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            乡/镇/社区：{{
              yangBenShuData.bData
            }}个&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            村：{{ yangBenShuData.cData }}个
          </div>
        </div>
        <div class="bgc content_l_5">
          <div class="chart1" id="l_chart_diqufengbu"></div>
        </div>
        <div class="content_l_6">
          <div class="bgc content_l_6_box">
            <div class="box_title">
              <span class="title">民俗活动</span>
              <span class="box_title_r" @click="goTo('/mshd')">more>>></span>
            </div>
            <div class="box_txt">
              <div class="box_txt_1">
                <ul>
                  <li>传统体育：{{ syDate.activity_sports }}种</li>
                  <li>传统庆典：{{ syDate.activity_celebration }}个</li>
                  <li>传统节日：{{ syDate.activity_festival }}个</li>
                </ul>
              </div>
              <div style="flex: 3; margin: 1%">
                <el-carousel height="100%" indicator-position="none">
                  <el-carousel-item
                    v-for="(item, index) in images_3"
                    :key="index"
                  >
                    <el-image
                      style="width: 100%; height: 100%"
                      :src="item.idView"
                      fit="fit"
                    ></el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
          <div class="bgc content_l_6_box">
            <div class="box_title">
              <span class="title">特色风味</span>
              <span class="box_title_r" @click="goTo('/tsfw')">more>>></span>
            </div>
            <div class="box_txt">
              <div class="box_txt_1">
                <ul>
                  <li>主食：{{ syDate.feature_food }}种</li>
                  <li>小吃：{{ syDate.feature_snack }}种</li>
                  <li>饮料：{{ syDate.feature_drinks }}种</li>
                </ul>
              </div>
              <div style="flex: 3; margin: 1%">
                <el-carousel height="100%" indicator-position="none">
                  <el-carousel-item
                    v-for="(item, index) in images_4"
                    :key="index"
                  >
                    <el-image
                      style="width: 100%; height: 100%"
                      :src="item.idView"
                      fit="fit"
                    ></el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_c">
        <syMap></syMap>
      </div>
      <div class="content_r">
        <div class="bgc content_r_1">
          <div class="content_r_1_zs">
            <span class="txtc">{{
              +syDate.story_unity + +syDate.story_red + +syDate.story_legend
            }}</span>
            <p>总数</p>
          </div>
          <div class="chart2" id="r_chart_mingxiang"></div>
          <div class="more" @click="goTo('/mjgs')">more>>></div>
        </div>
        <div class="bgc content_r_2">
          <div class="content_r_2_title title">物质文明</div>
          <div class="content_r_2_box">
            <div class="box_1">
              <ul>
                <li>文化设施：{{ syDate.matter_culture }}个</li>
                <li>休闲设施：{{ syDate.matter_play }}个</li>
                <li>健身设施：{{ syDate.matter_fitness }}个</li>
                <li>便利设施：{{ syDate.matter_convenience }}个</li>
                <li>卫生设施：{{ syDate.matter_sanitation }}个</li>
                <li>开发景区：{{ syDate.matter_scenic }}个</li>
                <li>电子商站：{{ syDate.matter_shop }}个</li>
              </ul>
            </div>
            <div style="flex: 3; margin: 1%">
              <el-carousel height="100%" indicator-position="none">
                <el-carousel-item
                  v-for="(item, index) in images_5"
                  :key="index"
                >
                  <el-image
                    style="width: 100%; height: 100%"
                    :src="item.idView"
                    fit="fit"
                  ></el-image>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
        <div class="bgc content_r_3">
          <div class="r_3_box">
            <p class="content_r_3_title title">少数民族非遗</p>
            <div class="content_r_3_txt">
              <p class="zs txtc">{{ syDate.culture_heritage }}</p>
              <p>总数</p>
            </div>
          </div>
          <div style="flex: 3; margin: 1%; height: 17vh">
            <el-carousel height="100%" indicator-position="none">
              <el-carousel-item v-for="(item, index) in images_6" :key="index">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="item.idView"
                  fit="fit"
                ></el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="bgc content_r_4">
          <div class="r_4_box">
            <div class="box_txt"><span>文旅支持</span></div>
            <div class="box_img">
              <img src="../assets/wx.png" alt="" style="height: 90%" />
            </div>
          </div>
          <div class="r_4_box">
            <div class="box_txt"><span>教育支持</span></div>
            <div class="box_img" @click="go">
              <img src="../assets/ma.png" alt="" style="height: 90%" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Head from "@/components/Head.vue";
import syMap from "@/components/syMap.vue";
import FlipClock from "../components/time/FlipClock.vue";

export default {
  name: "Home",
  components: {
    Head,
    syMap,
    FlipClock,
  },
  data() {
    return {
      // 少数民族简介轮播图
      images_1: [
        {
          id: 0,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/侗族服饰(2).png",
        },
        {
          id: 1,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/尖头瑶.png",
        },
        {
          id: 2,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/服饰.png",
        },
      ],
      images_2: [
        {
          id: 0,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/苗服(1).png",
        },
        {
          id: 1,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/银饰.png",
        },
        {
          id: 2,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/平头瑶.png",
        },
      ],
      images_3: [
        {
          id: 0,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/传统龙舟.jpg",
        },
        {
          id: 1,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/篝火晚会(1).png",
        },
        {
          id: 2,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/古尔邦节(2).png",
        },
        {
          id: 3,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/合拢会(1).png",
        },
      ],
      images_4: [
        {
          id: 0,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/包谷粑.png",
        },
        {
          id: 1,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/古瑶茶1.png",
        },
        {
          id: 2,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/古瑶茶.png",
        },
        {
          id: 3,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/谷雨茶.jpg",
        },
      ],
      images_5: [
        {
          id: 0,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/健身器材.png",
        },
        {
          id: 1,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/篮球场.jpeg",
        },
        {
          id: 2,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/商店.png",
        },
        {
          id: 3,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/戏台.jpeg",
        },
        {
          id: 4,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/宣传栏.png",
        },
        {
          id: 5,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/阅览室.png",
        },
      ],
      images_6: [
        {
          id: 0,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/回民武术(1).png",
        },
        {
          id: 1,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/麻阳船工.jpg",
        },
        {
          id: 2,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/瑶族女子拳.png",
        },
        {
          id: 3,
          idView:
            "https://www.bjdzhl.com/app/getFileURL/file/20240223/杖鼓舞.png",
        },
      ],

      headTxt: {
        title: "",
        txt: "",
      },

      yangBenData: [],
      yangBenLength: [],

      yangBenShuData: {
        aData: 0,
        bData: 0,
        cData: 0,
      },

      syDate: {},

      // 样本地区分布
      fenBuChar: null,

      // 民族乡村故事
      guShiChar: null,

      textShow: false,

      nowDate: null, //存放年月日变量
      nowTime: null, //存放时分秒变量
      timer: "", //定义一个定时器的变量
      currentTime: new Date(), // 获取当前时间
    };
  },
  created() {
    this.timer = setInterval(this.getTime, 1000);
  },

  mounted() {
    this.getShenList();

    this.getSYDate();

    // 样本地区分布
    this.fenBuEcharts();
  },
  methods: {
    getTime() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      const str = "";
      if (this.hour > 12) {
        this.hour -= 12;
        this.str = " AM";
      } else {
        this.str = " PM";
      }
      this.month = check(month);
      this.day = check(day);
      this.hour = check(hour);
      this.minute = check(minute);
      this.second = check(second);
      function check(i) {
        const num = i < 10 ? "0" + i : i;
        return num;
      }
      this.nowDate = year + "年" + this.month + "月" + this.day + "日";
      this.nowTime =
        this.hour + ":" + this.minute + ":" + this.second + this.str;
    },

    // 获取湖南省数据
    getShenList() {
      var date = JSON.parse(localStorage.getItem("date"));
      console.log(date, "湖南省数据");
      // 样本分布地区
      let data = date
        .map(function (elem) {
          return elem.region;
        })
        .join("、");
      this.yangBenData = data.split("、");
      console.log(this.yangBenData);
      // 样本分布地区数据
      this.yangBenLength = date.map(function (elem) {
        if (elem.slist[0].burg_id == 0) {
          return 0;
        } else {
          return parseInt(elem.slist.length);
        }
      });
      console.log(this.yangBenLength, "样本分布地区数据");
      // 样本数
      var b = [];
      date.forEach((element) => {
        var a = element.slist.map(function (elem) {
          return elem.region_burg;
        });
        b.push(a);
      });

      var c = [];
      for (let i = 0; i < b.length; i++) {
        for (var ii in b[i]) {
          c.push(b[i][ii]);
        }
      }
      var d = c.join("、");

      for (let i = 0; i < d.length; i++) {
        if (d[i] === "村") {
          this.yangBenShuData.cData++;
        }
        if (d[i] === "乡" || d[i] === "镇" || d[i] === "社区") {
          this.yangBenShuData.bData++;
        }
        if (d[i] === "县" || d[i] === "市") {
          this.yangBenShuData.aData++;
        }
      }
      console.log(this.yangBenShuData);

      this.fenBuEcharts();
    },

    // 获取首页统计数据
    getSYDate() {
      this.$http.get("/api/ssm/Api/index/listIndexs").then((r) => {
        console.log(r.data.items[0]);
        this.syDate = r.data.items[0];
        this.headTxt.txt = this.syDate.about_us;
        // 民族乡村故事
        this.guShiEcharts();
      });
    },

    // 样本地区分布
    fenBuEcharts() {
      this.fenBuChar = this.$echarts.init(
        document.getElementById("l_chart_diqufengbu")
      );
      //窗口变动，echart重绘
      window.addEventListener("resize", () => {
        this.fenBuChar.resize();
      });
      var option = {
        title: {
          text: "样本地区分布",
          left: "3%",
          top: "2%",
          textStyle: {
            color: "#333",
            fontSize: this.$fontSize.fontSize(0.2),
          },
        },
        grid: {
          top: "25%",
          left: "3%",
          right: "3%",
          bottom: "3%",
          containLabel: true,
        },
        legend: {},
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          axisLabel: {
            show: true,
            interval: 0, //使x轴上的文字显示完全,
            fontSize: this.$fontSize.fontSize(0.1),
            color: "#000",
            fontWeight: 900,
          },
          data: this.yangBenData,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#FFDE94" },
                { offset: 0.5, color: "#FFDE94" },
                { offset: 1, color: "#CCFFFF" },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#9999FF" },
                  { offset: 0.7, color: "#9999FF" },
                  { offset: 1, color: "#83bff6" },
                ]),
              },
            },
            data: this.yangBenLength,
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
          },
        ],
      };
      this.fenBuChar.setOption(option);
    },

    // 民族乡村故事
    guShiEcharts() {
      this.guShiChar = this.$echarts.init(
        document.getElementById("r_chart_mingxiang")
      );
      //窗口变动，echart重绘
      window.addEventListener("resize", () => {
        this.guShiChar.resize();
      });
      var optoin = {
        title: {
          text: "民族乡村故事",
          left: "3%",
          top: "2%",
          textStyle: {
            color: "#333",
            fontSize: this.$fontSize.fontSize(0.2),
          },
        },
        tooltip: {
          trigger: "item",
        },
        // legend: {
        //   orient: 'vertical',
        //   width: '50%',
        //   top: "30%",//图例组件离容器上侧的距离
        //   left: "30%",//图例组件离容器左侧的距离
        //   textStyle: {
        //     color: "#333"
        //   }
        // },
        series: [
          {
            type: "pie",
            avoidLabelOverlap: false,
            radius: "90%",
            center: ["65%", "50%"],
            itemStyle: {
              borderRadius: 3,
              borderColor: "#666",
            },
            label: {
              normal: {
                formatter: "{c|{c}}\n{b|{b}}",
                position: "inner",
                rich: {
                  a: {
                    color: "#ccc",
                    fontSize: 10,
                    lineHeight: 20,
                  },
                  b: {
                    //name 文字样式
                    fontSize: 10,
                    lineHeight: 20,
                    color: "#666",
                  },
                  c: {
                    //value 文字样式
                    fontSize: 10,
                    lineHeight: 20,
                    color: "#666",
                    align: "center",
                  },
                },
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: this.syDate.story_red,
                itemStyle: {
                  color: "#FFCC99",
                },
                name: "红色故事",
              },
              {
                value: this.syDate.story_legend,
                itemStyle: {
                  color: "#CC99CC",
                },
                name: "民间传说",
              },
              {
                value: this.syDate.story_unity,
                itemStyle: {
                  color: "#FF6666",
                },
                name: "团结故事",
              },
            ],
          },
        ],
      };
      this.guShiChar.setOption(optoin);
    },

    // 跳转
    goTo(toPath) {
      this.$router.push(toPath);
    },

    go() {
      // var url = 'http://www.www.bjdzhl.com/'
      window.open("http://www.www.bjdzhl.com", "_blank");
    },
  },
  beforeDestoryed() {
    // 组件销毁前移除监听,防止内存泄露
    window.removeEventListener("resize");

    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除定时器
    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  font-size: calc(100vw * 18 / 1920) !important;
  text-indent: 2em;
  p{
    padding: 0.5vh 0;
  }
}

.home {
  .content {
    display: flex;

    .content_l,
    .content_c,
    .content_r {
      // background-color: #ccc;
      margin: 0.5%;
    }

    .content_l {
      width: 34%;
      height: 91.8vh;
      position: relative;

      .content_l_1 {
        display: flex;
        height: 9vh;
        padding-left: 1vw;
        line-height: 9vh;
        font-size: calc(100vw * 40 / 1920);
        color: #666;
        font-family: "黑体";
        font-weight: 1000;
      }

      .content_l_2 {
        margin-top: 1vh;
        height: 20vh;
        position: relative;

        .content_l_2_title {
          text-align: center;
          padding: 1%;
          font-weight: 700;
        }

        .content_l_2_box {
          display: flex;
          height: 14.5vh;

          div {
            flex: 1;
            height: 100%;

            ul {
              margin-top: 7%;
              margin-left: 3%;

              li {
                margin: 1.2vh 0;
                font-size: calc(100vw * 14 / 1920);
              }
            }
          }

          .more {
            position: absolute;
            right: 3%;
            top: 5%;
            cursor: pointer;
          }
        }
      }

      .content_l_3 {
        margin-top: 1vh;
        height: 9vh;

        .content_l_3_title {
          text-align: center;
          padding: 1%;
          font-weight: 700;
        }

        /deep/ .el-divider--horizontal {
          margin: 2vh auto;
          width: 90%;
          height: 3px;
          background-color: #666;
        }

        /deep/ .el-divider__text {
          padding: 5px 20px;
          font-size: calc(100vw * 20 / 1920);
          font-weight: 900;
          border-radius: 10px;
        }
      }

      .content_l_4 {
        margin-top: 1vh;
        height: 9vh;

        .content_l_4_title {
          text-align: center;
          padding: 1%;
          font-weight: 700;
          border-bottom: 2px solid #666;
          margin: 0 5%;
        }

        .content_l_4_text {
          padding: 2%;
          text-align: center;
        }
      }

      .content_l_5 {
        margin-top: 1vh;
        height: 20vh;

        .chart1 {
          width: 100%;
          height: 100%;
        }
      }

      .content_l_6 {
        position: absolute;
        display: flex;
        bottom: 0;
        left: 0;
        width: 42vw;
        height: 20vh;
        z-index: 10;

        .content_l_6_box {
          flex: 1;
          margin: 1% 1% 0 0;

          .box_title {
            padding: 2% 2% 1% 2%;
            font-weight: 700;
            text-align: justify;

            .box_title_r {
              float: right;
              cursor: pointer;
            }

            .box_title_r:hover {
              color: rgb(30, 116, 255);
            }
          }

          .box_txt {
            display: flex;
            height: 14vh;

            div {
              height: 100%;
            }

            .box_txt_1 {
              flex: 2;
              // margin: 1%;
              // height: 100% - 2px;
              border-top: 2px solid #000;

              ul {
                margin: 20% 0;

                li {
                  margin: 7% 5%;
                  text-align: left;
                  font-size: calc(100vw * 16 / 1920);
                }
              }
            }
          }
        }
      }
    }

    .content_c {
      width: 39%;
    }

    .content_r {
      width: 25%;

      .content_r_1 {
        position: relative;
        height: 18vh;

        .content_r_1_zs {
          position: absolute;
          top: 10%;
          left: 5%;
          text-align: center;

          span {
            font-size: calc(100vw * 80 / 1920);
            font-weight: 1000;
          }

          p {
            font-size: calc(100vw * 25 / 1920);
          }
        }

        .more {
          position: absolute;
          bottom: 3%;
          right: 3%;
          cursor: pointer;
          font-size: calc(100vw * 16 / 1920);
        }

        .more:hover {
          color: rgb(30, 116, 255);
        }

        .chart2 {
          width: 100%;
          height: 100%;
        }
      }

      .content_r_2 {
        height: 30vh;
        margin-top: 1vh;

        .content_r_2_title {
          padding: 1%;
          margin: 0 30%;
          text-align: center;
          font-weight: 1000;
          border-bottom: 2px solid #000;
        }

        .content_r_2_box {
          display: flex;

          div {
            height: 24.5vh;
          }

          .box_1 {
            flex: 2;
            margin: 1%;

            ul {
              margin: 2% 0;

              li {
                margin: 6% 5%;
                text-align: left;
                font-size: calc(100vw * 18 / 1920);
              }
            }
          }
        }
      }

      .content_r_3 {
        display: flex;
        height: 18vh;
        margin-top: 1vh;

        div {
          height: 17vh;
        }

        .r_3_box {
          flex: 2;
          margin: 1%;

          .content_r_3_title {
            font-weight: 1000;
            text-align: center;
          }

          .content_r_3_txt {
            margin-top: -5%;
            text-align: center;

            .zs {
              font-size: calc(100vw * 80 / 1920);
              font-weight: 1000;
            }

            p {
              font-size: calc(100vw * 25 / 1920);
            }
          }
        }
      }

      .content_r_4 {
        height: 18vh;
        margin-top: 1vh;
        display: flex;
        .r_4_box {
          flex: 1;
          margin: auto;
          text-align: center;

          .box_img {
            margin: auto;
            width: 8vw;
            height: 13vh;
            // background-color: #fff;
          }

          .box_txt {
            font-size: calc(100vw * 20 / 1920);
            font-weight: 900;
            margin-bottom: 1vh;
          }
        }
      }
    }
  }
}
</style>